export default "/static/dashboard/build/app/img/v2/7c6df7b8ef2fcbbcfa390a893e5f1b85.png";